import React from 'react'
import { get } from 'lodash'
import { Col, Container, Row } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import ContentBlock from 'components/atoms/ContentBlock/ContentBlock'
import Typography from 'components/atoms/Typography/Typography'
import Lightbox from 'components/molecules/Lightbox'
import { userCheckMobileScreen } from 'helpers/tools'

// Styles
import 'slick-carousel/slick/slick.css'
import './StaffGallery.scss'

function StaffGallery({ data }) {
  const isMobile = userCheckMobileScreen()

  return (
    <Container className="staff-gallery pt-4" fluid>
      <Container>
        <Row>
          <Col sm={12}>
            <ContentBlock>
              <Typography variant="h2" color="primary" cssClass="title-bold-md">
                {get(data, 'title')}
              </Typography>
              <Typography variant="span" color="gray-100" cssClass="bloco-conteudo-preview">
                {ReactHtmlParser(get(data, 'description.value'))}
              </Typography>
            </ContentBlock>
          </Col>
        </Row>
        <Row className="pt-4">
          {data.staffs.map(({ entity }, index) => (
            <Col xs={6} md={3} className="mb-4 mb-lg-5" key={get(entity, 'uuid') + index}>
              <Lightbox
                allImages={data.staffs.map(({ entity }) => ({
                  image: get(entity, 'media.entity.images'),
                  title: entity?.title,
                  subtitle: entity?.subtitle,
                }))}
                image={
                  isMobile ? get(entity, 'media.entity.images.medium.url') : get(entity, 'media.entity.images.wide.url')
                }
                imageAlt={get(entity, 'media.entity.images.alt')}
                index={index}
                title={get(entity, 'title')}
                subtitle={get(entity, 'subtitle')}
              >
                {get(entity, 'body.value')}
              </Lightbox>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  )
}

export default StaffGallery
